
import NavBar from '../components/NavBar';

export function Header () {

 return (
  <header className="app-title" style={{ textAlign: 'center', margin: '32px 0 12px', position: 'relative' }}>
    <h1 style={{ marginBottom: '4px' }}>Film Revival NYC</h1>
    <div style={{
      width: '48px',
      height: '2px',
      background: '#d4a843',
      margin: '8px auto 12px',
      borderRadius: '1px'
    }} />
    <p className="tagline">Every Revival, All in One Calendar</p>
    <NavBar />
  </header>
 )
}